import { useEffect, type ReactNode } from "react";

export function Modal({ titulo, sub, onCerrar, children, pie, ancho = 520 }: {
  titulo: string; sub?: string; onCerrar: () => void; children: ReactNode; pie?: ReactNode; ancho?: number;
}) {
  useEffect(() => {
    const h = (e: KeyboardEvent) => { if (e.key === "Escape") onCerrar(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onCerrar]);
  return (
    <div className="velo" onClick={onCerrar}>
      <div className="modal" role="dialog" aria-modal="true" aria-label={titulo} onClick={(e) => e.stopPropagation()} style={{ width: ancho }}>
        <h2 className="subtitulo" style={{ marginBottom: sub ? 4 : 16 }}>{titulo}</h2>
        {sub && <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 16 }}>{sub}</p>}
        {children}
        {pie && <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>{pie}</div>}
      </div>
    </div>
  );
}

export function Campo({ label, pista, error, children, span }: { label: string; pista?: string; error?: string; children: ReactNode; span?: boolean }) {
  return (
    <div className="campo" style={span ? { gridColumn: "1 / -1" } : undefined}>
      <label>{label}</label>
      {children}
      {error ? <span className="error">{error}</span> : pista ? <span className="pista">{pista}</span> : null}
    </div>
  );
}

export function Seg<T extends string>({ value, onChange, opciones }: { value: T; onChange: (v: T) => void; opciones: (T | [T, string])[] }) {
  return (
    <div className="seg">
      {opciones.map((o) => {
        const [v, l] = Array.isArray(o) ? o : [o, o];
        return <button key={v} type="button" className={value === v ? "activo" : ""} onClick={() => onChange(v)}>{l}</button>;
      })}
    </div>
  );
}

export const grid2 = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 16px" } as const;
